export const getTabIndexFromExpression = (expression?: string): number => {
  if (!expression) return 0; // Default to first tab if no expression

  const parts = expression.split(" ");
  if (parts.length !== 5) return 0; // Invalid cron format

  // Monthly pattern variations:
  // "5 1 20 * *" - specific day of month
  // "5 1 20 */2 *" - every 2 months on day 20
  // "5 1 */5 * *" - every 5 days of month
  if (parts[2] !== "*" || parts[3] !== "*") {
    return 3; // Monthly tab
  }
  // Weekly pattern: "5 1 * * 1,3,5" (days of week specified)
  else if (parts[4] !== "*") {
    return 2; // Weekly tab
  }
  // Daily pattern: "5 1 * * *"
  else if (parts[1] !== "*" && !parts[1].startsWith("*/")) {
    return 1; // Daily tab
  }
  // Hourly pattern: "5 */3 * * *" or "5 0 * * *"
  else {
    return 0; // Hourly tab
  }
};
